<template>
    <v-icon v-if="!loginPage" color="white" @click="logout">power_settings_new</v-icon>
</template>

<script>
    import {SECURITY_LOGOUT} from "../../store/actions.type";

    export default {
        name: "LogoutButton",
        computed: {
            loginPage: function () {
                return this.$router.currentRoute.name === 'login';
            }
        },
        methods: {
            /**
             * Il s'agit simplement de vider le token puis rediriger sur login
             * Pas d'action backend requise
             */
            logout() {
                this.$store.dispatch(SECURITY_LOGOUT);
                this.$router.push({name: 'login'});
            },
        }
    };
</script>

<style scoped lang="scss">
</style>
